// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"10aff322","977":"002546ef"}[chunkId] + ".chunk.js";
};